import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatToolbarModule} from '@angular/material/toolbar';
import {RouterModule} from '@angular/router';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { BottomBarComponent } from './bottom-bar/bottom-bar.component';
import { LabelButtonComponent } from './label-button/label-button.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { StrongPasswordValidatorDirective } from './directives/strong-password-validator.directive';
import { PasswordValidatorDirective } from './directives/password-validator.directive';
import {PendingChangesGuard} from './pending-changes.guard';
import { NotificationDialogueComponent } from './notifications/notification-dialogue/notification-dialogue.component';
import { ProgressComponent } from './progress/progress.component';



@NgModule({
  declarations: [
    ContentHeaderComponent,
    BottomBarComponent,
    LabelButtonComponent,
    NotificationsComponent,
    StrongPasswordValidatorDirective,
    PasswordValidatorDirective,
    NotificationDialogueComponent,
    ProgressComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatDialogModule,
    MatToolbarModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ContentHeaderComponent,
    BottomBarComponent,
    LabelButtonComponent,
    StrongPasswordValidatorDirective,
    PasswordValidatorDirective,
    NotificationsComponent
  ],
  providers: [
    PendingChangesGuard
  ]
})
export class SharedModule { }
